// v2 campaign lane file — see app/v2/README.md. Owned by one build agent at a time;
// other agents and humans: do not edit. Routes here are HIDDEN (reachable only via
// /v2-screens and deep links) and every element must wrap in <RequireAuth>.
import { lazy, type ReactElement } from 'react';
import { Route } from 'react-router-dom';
import { RequireAuth } from '@/shared/auth/RequireAuth';

// Rank #3 (v2_wins.html §r3, 20/20) — PB w_orderstat / browse cfg `orders-status`.
const OrderStatus2Page = lazy(() => import('@/features/orders/status2/OrderStatus2Page'));
// Rank #4 (v2_wins.html §r4, 20/20) — PB w_order_tag_search, the waving workbench.
const Waving2Page = lazy(() => import('@/features/orders/waving2/Waving2Page'));
// Rank #5 (v2_wins.html §r5, 19/20) — PB w_order_maint, Order Inquiry / Maintenance.
const OrderInquiry2Page = lazy(() => import('@/features/orders/inquiry2/OrderInquiry2Page'));
// Rank #6 (v2_wins.html §r6, 19/20) — PB w_waves, the wave floor's home screen.
const WaveStatus2Page = lazy(() => import('@/features/orders/wavestatus2/WaveStatus2Page'));
// Rank #12 (v2_wins.html §r12, 18/20) — PB w_wave_det, the 7-tab wave inquiry.
const WaveDetail2Page = lazy(() => import('@/features/wave-detail/v2/WaveDetail2Page'));
// Rank #14 (v2_wins.html §r14, 18/20) — PB w_rep_wave, the Automatic Waving workbench
// (an ops workbench misfiled under /reports/).
const WaveAuto2Page = lazy(() => import('@/features/reports/wave2/WaveAuto2Page'));
// Rank #23 (v2_wins.html §r23, 17/20) — PB w_order_maint's browse half, w_order_search
// (features/orders/maintenance/OrderMaintenancePage.tsx; the ROUTE is /orders/search).
const OrderSearch2Page = lazy(() => import('@/features/orders/search2/OrderSearch2Page'));
// Rank #24 (v2_wins.html §r24, 17/20) — PB w_picks, the nine-mode pick inquiry.
const Picks2Page = lazy(() => import('@/features/picks/v2/Picks2Page'));
// Rank #26 (v2_wins.html §r26, 17/20) — PB w_order_status_dashboard.
const OrderDashboard2Page = lazy(() => import('@/features/orders/dashboard2/OrderDashboard2Page'));

export const slot1Routes: ReactElement[] = [
  <Route
    key="/orders/status2"
    path="/orders/status2"
    element={
      <RequireAuth>
        <OrderStatus2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/orders/waving2"
    path="/orders/waving2"
    element={
      <RequireAuth>
        <Waving2Page />
      </RequireAuth>
    }
  />,
  // Order Inquiry v2 renders bare (a lookup card) and keyed — the campaign contract's
  // "every page renders WITHOUT route params" plus the real drill target.
  <Route
    key="/orders/inquiry2"
    path="/orders/inquiry2"
    element={
      <RequireAuth>
        <OrderInquiry2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/orders/inquiry2/:orderId/:releaseNum"
    path="/orders/inquiry2/:orderId/:releaseNum"
    element={
      <RequireAuth>
        <OrderInquiry2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/waves/status2"
    path="/waves/status2"
    element={
      <RequireAuth>
        <WaveStatus2Page />
      </RequireAuth>
    }
  />,
  // Wave Detail v2 renders bare (a warehouse + wave lookup card) and keyed — the campaign
  // contract's "every page renders WITHOUT route params" plus the real drill target.
  <Route
    key="/orders/wave-detail2"
    path="/orders/wave-detail2"
    element={
      <RequireAuth>
        <WaveDetail2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/orders/wave-detail2/:warehouseId/:waveSeqNum"
    path="/orders/wave-detail2/:warehouseId/:waveSeqNum"
    element={
      <RequireAuth>
        <WaveDetail2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/waves/auto2"
    path="/waves/auto2"
    element={
      <RequireAuth>
        <WaveAuto2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/orders/search2"
    path="/orders/search2"
    element={
      <RequireAuth>
        <OrderSearch2Page />
      </RequireAuth>
    }
  />,
  // Picks v2 is param-free: its nine modes live in ?by= (the URL contract four calling
  // screens already use), never in the path — see picks2Model.readPicksSelectBy.
  <Route
    key="/manage/picks2"
    path="/manage/picks2"
    element={
      <RequireAuth>
        <Picks2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/orders/dashboard2"
    path="/orders/dashboard2"
    element={
      <RequireAuth>
        <OrderDashboard2Page />
      </RequireAuth>
    }
  />,
];
